// 以下定义作为 portal 项目的子路径挂载到 nginx
var SubPackageSlugEnum;
(function (SubPackageSlugEnum) {
    SubPackageSlugEnum["Reception"] = "cf";
    SubPackageSlugEnum["Center"] = "ct";
    SubPackageSlugEnum["Corporate"] = "cm";
    SubPackageSlugEnum["Content"] = "cs";
})(SubPackageSlugEnum || (SubPackageSlugEnum = {}));
const isNode = typeof window === 'undefined';
const ua = isNode ? '' : navigator.userAgent;
const uaLowerCase = ua.toLowerCase();
const isAndroid = /android/i.test(ua);
const isChrome = /chrome/i.test(ua);
const isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua));
const isPhone = /(?:iPhone)/.test(ua) && !isTablet;
const isPOPO = ua.indexOf('POPO') > -1;
const isWechat = /MicroMessenger/i.test(ua);
const isQQ = ua.match(/QQ\/[0-9]/i);
const isQQBrowser = ua.indexOf('MQQBrowser') > -1;
const isUC = /UCBrowser/i.test(ua);
const isBaidu = ua.indexOf('baiduboxapp') !== -1;
const isYujian = ua.indexOf('L20Share') > -1;
const isPc = !isPhone && !isAndroid && !isTablet;
const isSafari = uaLowerCase.indexOf('safari') > -1 && uaLowerCase.indexOf('chrome') === -1;
const isHeadlessChrome = /HeadlessChrome/.test(ua);
const isIOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
const isYujianApp = /L20/i.test(ua);
const ACTIVITY_CENTER_FROM_LOGIN_FLAG = 'FROM-LOGIN';

export { ACTIVITY_CENTER_FROM_LOGIN_FLAG, SubPackageSlugEnum, isAndroid, isBaidu, isChrome, isHeadlessChrome, isIOS, isNode, isPOPO, isPc, isPhone, isQQ, isQQBrowser, isSafari, isTablet, isUC, isWechat, isYujian, isYujianApp };
